import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'sticker', 'Sticker', [["path",{"d":"M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8"}],["path",{"d":"M20 12a8 8 0 1 1 -8 -8"}]]);